<template>
  <div class="secondary">
    <div class="product-gallery">
      <v-container class="py-10" fluid>
        <v-row>
          <v-col sm="6" md="12" lg="6" xl="4">
            <!-- <v-col sm="6" md="4" xl="3"> -->
            <product-map-link :map-link="mapLink" :background-image="mapImage"></product-map-link>
          </v-col>
          <v-col sm="6" md="12" lg="6" xl="8" v-if="images && images.length > 0">
            <!-- <v-col sm="6" md="8" lg="9"> -->
            <nav
              class="product-gallery__nav"
              v-if="!(isEnd && isBeginning) && ($vuetify.breakpoint.sm || $vuetify.breakpoint.lgAndUp)"
            >
              <ng-button
                class="mx-2"
                @click="prev"
                :disabled="isBeginning"
                icon
                depressed
                bordered
                icon-name="mdi-arrow-left"
              ></ng-button>
              <ng-button
                class="mx-2"
                @click="next"
                :disabled="isEnd"
                icon
                depressed
                bordered
                icon-name="mdi-arrow-right"
              ></ng-button>
            </nav>
            <ng-swiper-lightbox
              ref="gallery"
              :options="galleryOptions"
              :images="images"
              caption-view="tape"
              caption-value="caption"
              caption-position="bottom-left"
              :navigation="$vuetify.breakpoint.xs || $vuetify.breakpoint.md"
              navigation-dark
              @slideChange="onSlideChange"
              @show:lightbox="onImageShow"
            ></ng-swiper-lightbox>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import NgSwiperLightbox from '@ngservices_front/components/ui/NgSwiperLightbox.vue';
import ProductMapLink from './ProductMapLink.vue';

export default {
  name: 'ProductGallery',
  components: {
    NgSwiperLightbox,
    ProductMapLink,
  },
  props: {
    mapLink: {
      type: String,
    },
    mapImage: {
      type: String,
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      galleryOptions: {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          // [this.$vuetify.breakpoint.thresholds.sm]: {
          //   slidesPerView: 2,
          // },
          // [this.$vuetify.breakpoint.thresholds.md]: {
          //   slidesPerView: 3,
          // },
          [this.$vuetify.breakpoint.thresholds.lg]: {
            slidesPerView: 2,
          },
        },
      },
      isBeginning: false,
      isEnd: false,
    };
  },
  mounted() {
    if (this.images && this.images.length > 0) this.checkEdges();
  },
  methods: {
    next() {
      this.$refs.gallery.slideNext();
    },
    prev() {
      this.$refs.gallery.slidePrev();
    },
    checkEdges() {
      this.isBeginning = this.$refs.gallery.$refs.gallery.isBeginning;
      this.isEnd = this.$refs.gallery.$refs.gallery.isEnd;
    },
    onSlideChange() {
      if (window.ym) window.ym(42050389, 'reachGoal', 'product_gallery_nav');
      this.checkEdges();
    },
    onImageShow() {
      if (window.ym) window.ym(42050389, 'reachGoal', 'open_product_photo');
    },
  },
};
</script>

<style lang="scss" scoped>
.product-gallery {
  position: relative;
  // max-width: 1460px;

  &__nav {
    position: absolute;
    right: 24px;
    top: -20px;
    z-index: 2;

    &::v-deep .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: $gray-light !important;
    }
  }
}
</style>
